import { render, staticRenderFns } from "./prefectures.vue?vue&type=template&id=e22860f0&scoped=true"
import script from "./prefectures.vue?vue&type=script&lang=js"
export * from "./prefectures.vue?vue&type=script&lang=js"
import style0 from "./prefectures.vue?vue&type=style&index=0&id=e22860f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22860f0",
  null
  
)

export default component.exports